import { ChangeDetectionStrategy, Component, Inject, Input } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { TEAM_CONFIGURATION_PAGE } from "@common/page-route-providers";
import { IAdaptRoute } from "@common/route/page-route-builder";
import { IAdaptLinkObject } from "@common/route/route.service";
import { ConfigureFeatureBase } from "@org-common/lib/configuration/base-components/configure-feature-base";
import { IConfigItem } from "@org-common/lib/configuration/configuration.interfaces";
import { ConfigurationService } from "@org-common/lib/configuration/configuration.service";
import { ConfigArea } from "@org-common/lib/configuration/configuration-types";
import { CommonTeamsService } from "@org-common/lib/teams/common-teams.service";
import { CommonTeamsAuthService } from "@org-common/lib/teams/common-teams-auth.service";
import { lastValueFrom } from "rxjs";

@Component({
    selector: "adapt-configure-owners-vision",
    templateUrl: "./configure-owners-vision.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ConfigureOwnersVisionComponent extends ConfigureFeatureBase {
    @Input() public configItem?: IConfigItem;

    public readonly CanConfigureTeam = CommonTeamsAuthService.ConfigureTeam;
    public ownerTeamLinks: { team: Team; route: IAdaptLinkObject }[] = [];

    public constructor(
        configurationService: ConfigurationService,
        private teamsService: CommonTeamsService,
        @Inject(TEAM_CONFIGURATION_PAGE) private teamConfigurationPageRoute: IAdaptRoute<{ teamId: number }>,
    ) {
        super(configurationService);
    }

    public async initialiseData() {
        const ownerTeams = await this.teamsService.promiseToGetActiveOwnerTeams();
        this.ownerTeamLinks = await Promise.all(ownerTeams.map(async (team) => ({
            team,
            route: await lastValueFrom(this.teamConfigurationPageRoute.getRouteObject(
                { teamId: team.teamId },
                { section: ConfigArea[ConfigArea.OwnersVision] },
            )),
        })));
    }
}
